import { Modal, Dropdown } from "bootstrap"

// Turbo snapshots the page right before navigating away. Anything Bootstrap has
// left open (modal, backdrop, dropdown) would come back frozen open on a back/forward
// visit, so close it all before the snapshot is taken. (Tooltips: see tooltips.js.)
const closeModals = () => {
  document.querySelectorAll(".modal.show").forEach((element) => {
    const modal = Modal.getInstance(element)
    if (modal) modal.dispose()
    element.classList.remove("show")
    element.style.display = "none"
    element.setAttribute("aria-hidden", "true")
    element.removeAttribute("aria-modal")
    element.removeAttribute("role")
  })
  document.querySelectorAll(".modal-backdrop").forEach((element) => element.remove())
  document.body.classList.remove("modal-open")
  document.body.style.removeProperty("overflow")
  document.body.style.removeProperty("padding-right")
}

const closeDropdowns = () => {
  document.querySelectorAll(".dropdown-menu.show, [data-bs-toggle='dropdown'].show").forEach((element) => {
    element.classList.remove("show")
    element.removeAttribute("data-bs-popper")
  })
  document.querySelectorAll("[data-bs-toggle='dropdown']").forEach((toggle) => {
    const dropdown = Dropdown.getInstance(toggle)
    if (dropdown) dropdown.dispose()
    toggle.setAttribute("aria-expanded", "false")
  })
}

document.addEventListener("turbo:before-cache", () => {
  closeModals()
  closeDropdowns()
})
